import { useEffect } from "react";
import { Icon } from "./Icons";

export function Toast({ msg, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, []);
  return <div className="toast"><Icon name="check" size={14} />{msg}</div>;
}
